<div mat-dialog-content>
    <modal-pqrFormModalNew (closeDialog)="onClose()" [formId]="formId"></modal-pqrFormModalNew>
</div>